import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './TicketModal.css';

export const TicketModal = ({ isOpen, onClose, booking }) => {
  if (!isOpen) return null;

  const event = booking?.eventId;
  const subscriptionDates = booking?.subscriptionDates || [];
  
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      weekday: 'long',
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  const formatShortDate = (dateString) => {
    if (!dateString) return 'TBD';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const formatMonthLabel = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  // Generate a ticket number from booking ID
  const ticketNumber = booking?._id?.slice(-8).toUpperCase() || 'XXXXXXXX';

  // Create QR code URL for Google Maps directions
  const venueAddress = event?.location?.address || '';
  const encodedAddress = encodeURIComponent(venueAddress);
  const qrCodeUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

  // Full location address
  const fullAddress = event?.location?.address || 'Location TBD';

  return (
    <div className="ticket-modal-overlay" onClick={onClose}>
      <div className="ticket-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="ticket-close-btn" onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        <div className="ticket-container-horizontal">
          {/* LEFT SECTION - Event Image */}
          <div className="ticket-left-section">
            <div className="ticket-event-image">
              <img src={event?.banner_Image} alt={event?.title} />
            </div>
          </div>

          {/* Vertical Divider with Circles */}
          <div className="ticket-vertical-divider">
            <div className="ticket-circle top"></div>
            <div className="ticket-dashed-line-vertical"></div>
            <div className="ticket-circle bottom"></div>
          </div>

          {/* MIDDLE SECTION - Event Details */}
          <div className="ticket-middle-section">
            <div className="ticket-header-horizontal">
              <div className="ticket-logo">
                <img src="/images/Asset-9.svg" alt="Hobi" />
              </div>
              <div className="ticket-badge">
                <span>CONFIRMED</span>
              </div>
            </div>

            <h2 className="ticket-event-title-h">{event?.title || 'Event'}</h2>

            <div className="ticket-details-grid-h">
              <div className="ticket-detail-item">
                <span className="detail-label">Date</span>
                <span className="detail-value">
                  {subscriptionDates.length > 1
                    ? `${formatShortDate(booking?.subscriptionStartDate || subscriptionDates[0])} - ${formatShortDate(booking?.subscriptionEndDate || subscriptionDates[subscriptionDates.length - 1])}`
                    : formatDate(event?.startDate)}
                </span>
              </div>
              <div className="ticket-detail-item">
                <span className="detail-label">Time</span>
                <span className="detail-value">{event?.startTime || '7:00 PM'}</span>
              </div>
           
              {subscriptionDates.length > 0 && (
                <div className="ticket-detail-item">
                  <span className="detail-label">Sessions</span>
                  <span className="detail-value">{subscriptionDates.length} classes</span>
                </div>
              )}
              {subscriptionDates.length > 0 && (
                <div className="ticket-detail-item">
                  <span className="detail-label">Subscription Month</span>
                  <span className="detail-value">{formatMonthLabel(booking?.subscriptionStartDate || subscriptionDates[0])}</span>
                </div>
              )}
            </div>

            {subscriptionDates.length > 0 && (
              <div className="subscription-dates-card">
                <div className="subscription-dates-header">
                  <span className="subscription-dates-title">
                    <i className="fas fa-calendar"></i> Covered Dates
                  </span>
                  <span className="subscription-dates-count">
                    {subscriptionDates.length} classes
                  </span>
                </div>
                <div className="subscription-dates-list">
                  {subscriptionDates.map((date) => (
                    <span key={date} className="subscription-date-chip">
                      {formatShortDate(date)}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {/* Full Location */}
            

            <div className="ticket-attendee-h">
             <div className="ticket-location-full">
              <span className="location-label">
                <i className="fas fa-map-marker-alt"></i> Full Address
              </span>
              <span className="location-value">{fullAddress}</span>
            </div>
            </div>
          </div>

          {/* Vertical Divider with Circles */}
          <div className="ticket-vertical-divider">
            <div className="ticket-circle top"></div>
            <div className="ticket-dashed-line-vertical"></div>
            <div className="ticket-circle bottom"></div>
          </div>

          {/* RIGHT SECTION - QR & Ticket Info */}
          <div className="ticket-right-section">
            <div className="ticket-qr-section-h">
              {/* <div className="ticket-qr-wrapper"> */}
                <QRCodeSVG 
                  value={qrCodeUrl}
                  size={120}
                  level="M"
                  includeMargin={false}
                  bgColor="#ffffff"
                  fgColor="#000000"
                />
              {/* </div> */}
              <span className="qr-label">Scan at venue</span>
            </div>

            <div className="ticket-info-section-h">
              <div className="ticket-number-h">
                <span className="label">Ticket #</span>
                <span className="value">{ticketNumber}</span>
              </div>
              <div className="ticket-amount-h">
                <span className="label">Amount Paid</span>
                <span className="value">₹{Math.round(booking?.amountPaid) || 0}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TicketModal;
